import { CommentType, CreateMessageBody, GetMessageParams, http } from '@Techedge/digitalportal-shared'
import { ForumUser } from '../models/forum/new-forum.model'

export interface CreateThreadBody {
    id?: string
    title: string
    description: string
    storeIdList: string[]
    enabledUsers: ForumUser[]
    smartFilter: any
}

export enum ThreadListSort {
    NEWEST_TOPIC = 'newest_topic',
    RECENT_ACTIVITY = 'recent_activity',
    MOST_COMMENTS = 'most_comments',
    TITLE = 'title',
}
export interface GetThreadListParams {
    sortAction?: ThreadListSort
    page?: string
    limit?: string
}

export interface CreateTopicBody extends CreateThreadBody {
    referenceThreadId: string
}

export class ForumService {
    static BASE_URL: string = process.env.REACT_APP_BASE_URL_BE
    static FORUM_URL: string = ForumService.BASE_URL + '/forumsapi'

    static headersObj = {
        headers: {
            'Accept-Language': '',
        },
        timeout: 180000,
    }

    static CreateThread = (body: CreateThreadBody) => {
        return http.post<any>(
            `${ForumService.FORUM_URL}/forum/thread`,
            body,
            ForumService.headersObj
        )
    }
    static EditThread = (body: CreateThreadBody) => {
        return http.put<any>(
            `${ForumService.FORUM_URL}/forum/thread`,
            body,
            ForumService.headersObj
        )
    }
    static CreateTopic = (body: CreateTopicBody) => {
        return http.post<any>(
            `${ForumService.FORUM_URL}/forum/topic`,
            body,
            ForumService.headersObj
        )
    }
    static EditTopic = (body: CreateTopicBody) => {
        return http.put<any>(
            `${ForumService.FORUM_URL}/forum/topic`,
            body,
            ForumService.headersObj
        )
    }
    static GetThreadList = (params: GetThreadListParams) => {
        return http.get<any>(`${ForumService.FORUM_URL}/forum/threads`, {
            ...ForumService.headersObj,
            params,
        })
    }
    static GetThread = (id: string) => {
        return http.get<any>(
            `${ForumService.FORUM_URL}/forum/thread/${id}`,
            ForumService.headersObj
        )
    }
    static GetTopic = (id: string, threadId: string) => {
        return http.get<any>(
            `${ForumService.FORUM_URL}/forum/topic/${id}?referenceThreadId=${threadId}`,
            ForumService.headersObj
        )
    }

    static CreateMessage = (body: CreateMessageBody, id?: string) => {
        return http[id ? 'put' : 'post']<any>(
            `${ForumService.FORUM_URL}/project/message${id ? `/${id}` : ''}`,
            { ...body },
            ForumService.headersObj
        )
    }

    static GetMessageList = (params: GetMessageParams) => {
        return http.get<any>(`${ForumService.FORUM_URL}/project/messages`, {
            ...ForumService.headersObj,
            params,
        })
    }
    static ReactionMessage = (
        body: Partial<CreateMessageBody>,
        id: string
    ) => {
        return http.put<any>(
            `${ForumService.FORUM_URL}/project/message/reaction/${id}`,
            { ...body },
            ForumService.headersObj
        )
    }
}
